import { render, staticRenderFns } from "./PurchaseAccount.vue?vue&type=template&id=df9aa72a&"
import script from "./PurchaseAccount.vue?vue&type=script&lang=js&"
export * from "./PurchaseAccount.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAccount.vue?vue&type=style&index=0&id=df9aa72a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports